import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../constants/interfaces'
import localeTranslations from '../config/translations'

interface LocaleTextProps {
  text: string
  isLocalUse?: boolean
}

const LocaleText = ({ text, isLocalUse = false }: LocaleTextProps) => {
  const locale = useSelector((state: RootState) => state.general.locale)
  const translations = useSelector((state: RootState) => state.config.translations)
  let translated = ''

  if (isLocalUse) {
    translated =
      localeTranslations[locale] && localeTranslations[locale][text]
        ? localeTranslations[locale][text]
        : localeTranslations['base'][text] || text
  } else {
    translated = translations[locale] && translations[locale][text] ? translations[locale][text] : text
  }
  return <>{translated}</>
}

export default LocaleText
